// extracted by mini-css-extract-plugin
export default {"parent":"Category_parent__qUn69","subparent":"Category_subparent__LShKt","child":"Category_child__vxL46","arrowbutton":"Category_arrowbutton__o6OYS"};